import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import ServiceFilter from '../../filters/ServiceFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter2.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import IssuerFilter from '../../filters/IssuerFilter.jsx';
import SchemeFilter from '../../filters/SchemeFilter.jsx';
import CardLogoFilter from '../../filters/CardLogoFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TransactionMediumFilter from '../../filters/TransactionMediumFilter.jsx';
import ProductTypeFilter from '../../filters/ProductTypeFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import FallBackFilter from '../../filters/FallBackFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';
import SkuFilter from '../../filters/SkuFilter.jsx';
import InternationalDomesticFilter from '../../filters/InternationalDomesticFilter.jsx';
import InstanceFilter from '../../filters/InstanceFilter.jsx';
import TransactionStatusFilter from '../../filters/TransactionStatusFilter.jsx';
import ProcessingCodeFilter from '../../filters/ProcessingCodeFilter.jsx';
import BoBankResponsecodeFilter from '../../filters/BoBankResponsecodeFilter.jsx';
import CiInnoResponsecode from '../../filters/CiInnoResponsecode.jsx';
import BiBankResponsecodeFilter from '../../filters/BiBankResponsecodeFilter.jsx';
import CoInnoResponseCode from '../../filters/CoInnoResponseCode.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
var LiveTraDumpTable='';

class EodTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            instance_name:"",
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            loading:false,
            is_void: 1,
            cardGradeIDs:'',
            schemeIDs:'',
            cardTypeIDs:'',
            txnissuerIDs:'',
            tenderModeIDs:'',
            txnTypeIDs: '',
            ciutidIds: '',
            slipData:'',
            isSettledIDs: '',
            is_fallback: 0,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            merchant_sku: 0,
            productTypeIDs: '',
            serviceTypeIDs: '',
            object_code:[],
            communicationIdIds:'',
            industryCategoryIds:'',
            isInternational:'',
            is_extra_column: 'no',
            extraColumns:[],
            extra_columns_query:'',
            extra_columns_merchant:'',
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            txn_status:'',
            processing_code:'',
            bank_responsecode:'',
            ci_inno_responsecode:'',
            bi_bank_responsecode:'',
            co_inno_responsecode:'',
            instance_name:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        let isExtraColumns = localStorage.is_extra_column;
        if(isExtraColumns==='yes') {
            let column_array=[];
            if(localStorage.extra_columns!='' || localStorage.extra_columns!=undefined) {
                column_array = localStorage.extra_columns.split(",");
            }
            this.setState({
                is_extra_column: isExtraColumns,
                extraColumns:column_array,
                extra_columns_query:localStorage.extra_columns_query,
                extra_columns_merchant:localStorage.extra_columns_merchant
            })

        }

        isReportAccess(AllAccessPermissions, 'transaction_dump_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_columns('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_columns(e) {
        this.setState({
            loading:true,
            is_record: true,
            is_exp_button: false
        })
        let tableHeaders=[];
        let tableBody = [];
        let headerList =[];
        axios.post(config.get('API_URL') + '/InternalReport/live-transaction-dump-reports-row', {
            fk_instance_id: this.state.instance_name,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            tender_mode: this.state.tenderModeIDs,
            ci_inno_processingcode: this.state.processing_code,
            transaction_status: this.state.txn_status,
            ci_inno_responsecode: this.state.ci_inno_responsecode,
            bi_bank_responsecode: this.state.bi_bank_responsecode,
            co_inno_responsecode: this.state.co_inno_responsecode,
            bo_bank_responsecode: this.state.bank_responsecode,
            acq_bank_codes: this.state.acqBankIds,
            transaction_type: this.state.txnTypeIDs,
            user_id: this.state.user_id,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            console.log("jhjhsgdhsgdh");
            console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length){
                //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                //console.log(keys);
                let keyVal='';

                keys.forEach(function (k) {
                    if(k=='id' || k=='latestversion') {
                        keyVal = '';
                    }
                    else{
                        keyVal = k;
                    }
                    tableHeaders.push({
                        sTitle: keyVal,
                        mData: k.replace(/\./g, '\\.')
                        //optionally do some type detection here for render function
                    });
                    tableBody.push({
                        data: k,
                    });
                    headerList.push(k);
                });
//                 console.log(tableHeaders);
//                 console.log(tableBody);
                this.setState({
                    loading: false,
                    is_record: true,
                    is_exp_button: true,
                    tableHeaders:tableHeaders,
                    tableBody:tableBody,
                    headerList:headerList
                });
                this._get_filtered_eod_transaction_report(tableHeaders, tableBody,headerList);
            }else {
                if ($.fn.DataTable.isDataTable('#LiveTraDumpTable')) {
                    $('#LiveTraDumpTable').DataTable().clear().destroy();
                }
                this.setState({
                    is_record: false,
                    loading: false,
                    isChange: false,
                    is_exp_button: false
                });
            }
        });
    }

    downLoadLiveTraReportCheck (e){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }

        let filters = {
            fk_instance_id: this.state.instance_name,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            ci_utid: this.state.ciutidIds,
            ci_tender_mode: this.state.tenderModeIDs,
            ci_inno_processingcode: this.state.processing_code,
            transaction_status: this.state.txn_status,
            ci_inno_responsecode: this.state.ci_inno_responsecode,
            bi_bank_responsecode: this.state.bi_bank_responsecode,
            co_inno_responsecode: this.state.co_inno_responsecode,
            bo_bank_responsecode: this.state.bank_responsecode,
            acq_bank_code: this.state.acqBankIds,
            transaction_type: this.state.txnTypeIDs,
            user_id: this.state.user_id,
            report_code:'live_transaction_dump_report',
            download: 1,
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/transactions_dump/live_report','transaction_dump_report',0);

    }

    _get_filtered_eod_transaction_report(tableHeaders, tableBody,headerList) {
        console.log(tableHeaders);
        console.log(tableBody);
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var days_beet = a.diff(b, 'days');

        if(days_beet>0) {
            alert("Please select a date range of 1 days at a time");
            return false
        }


        var postData = {
            fk_instance_id: this.state.instance_name,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            tender_mode: this.state.tenderModeIDs,
            ci_inno_processingcode: this.state.processing_code,
            transaction_status: this.state.txn_status,
            ci_inno_responsecode: this.state.ci_inno_responsecode,
            bi_bank_responsecode: this.state.bi_bank_responsecode,
            co_inno_responsecode: this.state.co_inno_responsecode,
            bo_bank_responsecode: this.state.bank_responsecode,
            acq_bank_codes: this.state.acqBankIds,
            transaction_type: this.state.txnTypeIDs,
            user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#LiveTraDumpTable')) {
            $('#LiveTraDumpTable').DataTable().clear().destroy();
        }

        LiveTraDumpTable = $('#LiveTraDumpTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/live-transaction-dump-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                aoColumns:tableHeaders,
                columns: tableBody,
            });


    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {

            this.refs.reloadUtid.ci_utid('','','',false,'');
        }


        this.refs.tenderModeFilter.restTenderModeFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.instanceFilter.resetinstanceFilter();
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.reloadTxnStatus.gettxnStatus(date_config.start_date_value, date_config.end_date_value);
        this.refs.reloadProcessingCode.getprocessingCode(date_config.start_date_value, date_config.end_date_value);
        this.refs.reloadBoBankResponceCode.getBoBankResponsecode(date_config.start_date_value, date_config.end_date_value);
        this.refs.reloadCiInnoResponceCode.getCiInnoResponsecode(date_config.start_date_value, date_config.end_date_value);
        this.refs.reloadBiBankResponceCode.getBiBankResponsecodeFilter(date_config.start_date_value, date_config.end_date_value);
        this.refs.reloadCoInnoResponceCode.getCoInnoResponseCodeFilter(date_config.start_date_value, date_config.end_date_value);
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            is_void:1,
            cardGradeIDs:'',
            schemeIDs:'',
            cardTypeIDs:'',
            txnissuerIDs:'',
            emiIssuerIDs:'',
            txnTypeIDs: '',
            ciutidIds: '',
            isSettledIDs: '',
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            merchant_sku:0,
            tenderModeIDs:'',
            is_fallback: 0,
            serviceTypeIDs: '',
            productTypeIDs: '',
            communicationIdIds:'',
            industryCategoryIds:'',
            isInternational:'',
            instance_name:'',
            processing_code:'',
            bank_responsecode:'',
            ci_inno_responsecode:'',
            bi_bank_responsecode:'',
            co_inno_responsecode:'',
            instance_name:'',
            txn_status:''
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        //this.refs.reloadIssuer._txn_issuer_bank(yestSend, todSend);
        this.refs.reloadTxnStatus.gettxnStatus(yestSend, todSend);
        this.refs.reloadProcessingCode.getprocessingCode(yestSend, todSend);
        this.refs.reloadBoBankResponceCode.getBoBankResponsecode(yestSend, todSend);
        this.refs.reloadCiInnoResponceCode.getCiInnoResponsecode(yestSend, todSend);
        this.refs.reloadBiBankResponceCode.getBiBankResponsecodeFilter(yestSend, todSend);
        this.refs.reloadCoInnoResponceCode.getCoInnoResponseCodeFilter(yestSend, todSend);

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    handleService = (serviceData) =>{
        const value = serviceData === null ? '' : serviceData.value;
        this.setState({
            isChange: true,
            serviceTypeIDs:value,
        })
    }
    handleTenderMode = (optionSelected, tenderModeIDs) =>
    {
        this.setState({
            tenderModeIDs:tenderModeIDs,
            isChange: true
        });
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            isChange: true
        });
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isChange: true
        });
    }
    handleIssuer = (optionSelected, issuerArray) =>
    {
        this.setState({
            txnissuerIDs:issuerArray,
            isChange: true
        });
    }
    handleScheme = (optionSelected, schemeArray) =>
    {
        this.setState({
            schemeIDs:schemeArray,
            isChange: true
        });
    }
    handleCard = (optionSelected, ceditArray) =>
    {
        this.setState({
            cardTypeIDs:ceditArray,
            isChange: true
        });
    }
    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleTransactionMedium = (optionSelected, TransactionMediumIds) =>
    {
        this.setState({
            communicationIdIds:TransactionMediumIds,
            isChange: true
        });
    }
    handleProduct = (productData) =>{
        const value = productData === null ? '' : productData.value;
        this.setState({
            isChange: true,
            productTypeIDs:value,
        })
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleInternationalFilter = (optionSelected) =>{
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            isInternational:value,
            isChange: true
        });
    }
    handleFallBack = (is_fallback) => {
        this.setState({is_fallback: is_fallback, isChange: true});
    }
    handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }
    handleSKU = (merchant_sku) => {
        this.setState({merchant_sku: merchant_sku, isChange: true});
    }
    handleInstance = (optionSelected) =>
    {
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            instance_name:value,
            isChange: true
        });
    }
    handleTxnStatus = (optionSelected, txnStatus) =>
    {
        this.setState({
            txn_status:txnStatus,
            isChange: true
        });
    }
    handleProcessingCode= (optionSelected, processing_code) =>
    {
        this.setState({
            processing_code:processing_code,
            isChange: true
        });
    }
    handleBoBankProcessingCode = (optionSelected, bo_bank_processing_code) =>
    {
        this.setState({
            bank_responsecode:bo_bank_processing_code,
            isChange: true
        });
    }
    handleCiInnoResponseCode = (optionSelected, ci_inno_responsecode) =>
    {
        this.setState({
            ci_inno_responsecode:ci_inno_responsecode,
            isChange: true
        });
    }
    handleBiBankResponsecodeFilter = (optionSelected, bi_bank_responsecode) =>
    {
        this.setState({
            bi_bank_responsecode:bi_bank_responsecode,
            isChange: true
        });
    }
    handleCoInnoResponseCode = (optionSelected, co_inno_responsecode) =>
    {
        this.setState({
            co_inno_responsecode:co_inno_responsecode,
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Transaction Dump Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Instance </label>
                                                <InstanceFilter ref="instanceFilter" onSelectinstance = {this.handleInstance} />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <TenderModeFilter ref="tenderModeFilter" onSelectTenderMode = {this.handleTenderMode} />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'Yes' />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Txn Status:</label>
                                                <TransactionStatusFilter ref= "reloadTxnStatus" onSelecttxnStatus = {this.handleTxnStatus} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Processing Code:</label>
                                                <ProcessingCodeFilter ref= "reloadProcessingCode" onSelectprocessingCode = {this.handleProcessingCode} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Bo Bank Response Code:</label>
                                                <BoBankResponsecodeFilter ref= "reloadBoBankResponceCode" onSelectBoBankResponsecode = {this.handleBoBankProcessingCode} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Ci inno response code:</label>
                                                <CiInnoResponsecode ref= "reloadCiInnoResponceCode" onSelectCiInnoResponsecode = {this.handleCiInnoResponseCode} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Bi Bank response code:</label>
                                                <BiBankResponsecodeFilter ref= "reloadBiBankResponceCode" onSelectBiBankResponsecodeFilter = {this.handleBiBankResponsecodeFilter} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Co Inno Response Code:</label>
                                                <CoInnoResponseCode ref= "reloadCoInnoResponceCode" onSelectCoInnoResponseCodeFilter = {this.handleCoInnoResponseCode} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>


                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this._get_filtered_eod_transaction_report.bind(this,this.state.tableHeaders,this.state.tableBody)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_exp_button ?
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadLiveTraReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>:null }
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="LiveTraDumpTable" className="table table-striped table-hover">

                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(EodTransactionReport)